(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  // Mobile accordion functionality
  document.addEventListener('DOMContentLoaded', function() {
    const menuToggles = document.querySelectorAll('.footer__menu-toggle');
    
    menuToggles.forEach(toggle => {
      toggle.addEventListener('click', function() {
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        const menuList = document.getElementById(this.getAttribute('aria-controls'));
        const chevron = this.querySelector('.footer__menu-chevron');
        
        // Close all other menus on mobile
        if (window.innerWidth <= 749) {
          menuToggles.forEach(otherToggle => {
            if (otherToggle !== this) {
              otherToggle.setAttribute('aria-expanded', 'false');
              const otherMenu = document.getElementById(otherToggle.getAttribute('aria-controls'));
              const otherChevron = otherToggle.querySelector('.footer__menu-chevron');
              if (otherMenu) {
                otherMenu.classList.remove('footer__menu-list--open');
              }
              if (otherChevron) {
                otherChevron.style.transform = 'rotate(0deg)';
              }
            }
          });
        }
        
        // Toggle current menu
        this.setAttribute('aria-expanded', !isExpanded);
        if (menuList) {
          menuList.classList.toggle('footer__menu-list--open');
        }
        if (chevron) {
          chevron.style.transform = !isExpanded ? 'rotate(180deg)' : 'rotate(0deg)';
        }
      });
    });

    // AJAX Newsletter Form Submission
    const newsletterForm = document.getElementById('ContactFooter');
    if (newsletterForm) {
      // Verify success message element exists
      const successMessageCheck = document.getElementById('ContactFooter-success');
      if (!successMessageCheck) {
        console.warn('Success message element not found in DOM');
      }
      
      newsletterForm.addEventListener('submit', function(e) {
        e.preventDefault();
        
        const form = this;
        const emailInput = form.querySelector('input[type="email"]');
        const submitButton = form.querySelector('button[type="submit"]');
        const buttonText = submitButton.querySelector('.footer__newsletter-button-text');
        const buttonLoader = submitButton.querySelector('.footer__newsletter-button-loader');
        const formFieldWrapper = form.querySelector('.footer__newsletter-field-wrapper');
        const errorMessage = form.querySelector('.footer__newsletter-message--error');
        const successMessage = document.getElementById('ContactFooter-success');
        const email = emailInput.value.trim();
        
        console.log('Form submitted, success message element:', successMessage);
        
        // Hide previous messages and show form field wrapper
        if (errorMessage) {
          errorMessage.style.display = 'none';
        }
        if (successMessage) {
          successMessage.classList.remove('show');
        }
        if (formFieldWrapper) {
          formFieldWrapper.style.display = 'flex';
        }
        
        // Validate email
        if (!email || !email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
          if (errorMessage) {
            errorMessage.textContent = 'Please enter a valid email address';
            errorMessage.style.display = 'block';
          }
          emailInput.focus();
          return;
        }
        
        // Show loading state
        submitButton.disabled = true;
        if (buttonText) buttonText.style.display = 'none';
        if (buttonLoader) buttonLoader.style.display = 'inline-flex';
        
        // Prepare form data - FormData automatically includes all form fields including CSRF token
        const formData = new FormData(form);
        
        // Get the form action URL (Shopify automatically sets this)
        const formAction = form.getAttribute('action') || '/contact';
        
        // Submit via AJAX
        fetch(formAction, {
          method: 'POST',
          body: formData,
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          },
          credentials: 'same-origin'
        })
        .then(response => {
          // Handle different response statuses
          if (response.status === 400) {
            return response.text().then(html => {
              // Try to extract error message from response
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              const responseError = doc.querySelector('.footer__newsletter-message--error') || 
                                   doc.querySelector('.errors') ||
                                   doc.querySelector('[class*="error"]');
              
              if (responseError) {
                throw new Error(responseError.textContent.trim() || 'Invalid request. Please check your email address.');
              }
              throw new Error('Invalid request. Please check your email address.');
            });
          }
          
          if (!response.ok) {
            throw new Error(`Server error: ${response.status}`);
          }
          
          // Store status for later use
          const status = response.status;
          return response.text().then(html => ({ html, status }));
        })
        .then(({ html, status }) => {
          console.log('Response received - Status:', status);
          // Try to parse the response
          try {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const responseForm = doc.querySelector('#ContactFooter');
            const responseError = doc.querySelector('.footer__newsletter-message--error') ||
                                 doc.querySelector('.errors') ||
                                 doc.querySelector('[class*="error"]');
            
            console.log('Response error element:', responseError);
            
            // Check for explicit error indicators first
            const hasError = responseError || 
                           html.includes('form-error') ||
                           html.includes('already subscribed') ||
                           html.includes('invalid email') ||
                           html.toLowerCase().includes('error');
            
            console.log('Has error:', hasError);
            
            if (hasError) {
              // Error from response
              let errorText = 'Something went wrong. Please try again.';
              if (responseError) {
                errorText = responseError.textContent.trim() || errorText;
              } else if (html.includes('already subscribed')) {
                errorText = 'This email is already subscribed.';
              } else if (html.includes('invalid email')) {
                errorText = 'Please enter a valid email address.';
              }
              
              if (errorMessage) {
                errorMessage.textContent = errorText;
                errorMessage.style.display = 'block';
              }
              emailInput.focus();
            } else {
              // If no errors and status is 200, treat as success
              // This is the default behavior for successful form submissions
              // Success - hide form field wrapper and show success message
              console.log('Showing success message');
              if (formFieldWrapper) {
                formFieldWrapper.style.display = 'none';
              }
              emailInput.value = '';
              emailInput.blur();
              
              if (successMessage) {
                console.log('Success message element found:', successMessage);
                successMessage.classList.add('show');
                successMessage.style.animation = 'footerSuccessFadeIn 0.3s ease-out';
                
                // Auto-hide after 5 seconds and restore form
                setTimeout(function() {
                  successMessage.style.animation = 'footerSuccessFadeOut 0.3s ease-out';
                  setTimeout(function() {
                    successMessage.classList.remove('show');
                    if (formFieldWrapper) {
                      formFieldWrapper.style.display = 'flex';
                    }
                  }, 300);
                }, 5000);
              } else {
                console.error('Success message element not found!');
              }
            }
          } catch (parseError) {
            console.error('Error parsing response:', parseError);
            // If parsing fails but response was 200, assume success
            if (status === 200) {
              if (formFieldWrapper) {
                formFieldWrapper.style.display = 'none';
              }
              emailInput.value = '';
              emailInput.blur();
              
              if (successMessage) {
                console.log('Showing success message (catch block)');
                if (formFieldWrapper) {
                  formFieldWrapper.style.display = 'none';
                }
                successMessage.classList.add('show');
                successMessage.style.animation = 'footerSuccessFadeIn 0.3s ease-out';
                
                setTimeout(function() {
                  successMessage.style.animation = 'footerSuccessFadeOut 0.3s ease-out';
                  setTimeout(function() {
                    successMessage.classList.remove('show');
                    if (formFieldWrapper) {
                      formFieldWrapper.style.display = 'flex';
                    }
                  }, 300);
                }, 5000);
              }
            } else {
              if (errorMessage) {
                errorMessage.textContent = 'Something went wrong. Please try again.';
                errorMessage.style.display = 'block';
              }
              emailInput.focus();
            }
          }
        })
        .catch(error => {
          console.error('Newsletter submission error:', error);
          if (errorMessage) {
            // Show specific error message if available, otherwise generic message
            const errorText = error.message && error.message !== 'Network response was not ok' 
              ? error.message 
              : 'Unable to subscribe. Please try again later.';
            errorMessage.textContent = errorText;
            errorMessage.style.display = 'block';
          }
          emailInput.focus();
        })
        .finally(() => {
          // Reset button state
          submitButton.disabled = false;
          if (buttonText) buttonText.style.display = 'inline';
          if (buttonLoader) buttonLoader.style.display = 'none';
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
